module.exports = __webpack_public_path__ + "img/Room5_013.321e06f4.svg";